import type { SourcingEventV2Dto } from "../../../../autogen/bff-api";

export type CommunicationSubTab =
  | "questions"
  | "publicQa"
  | "information"
  | "clarifications"
  | "internal";

// A private competition talks to its invited suppliers, not to a public feed, and the formal
// clarification dialog is a FOA § 23-5 construct with no counterpart outside public procurement.
export const communicationSubTabs = (event: SourcingEventV2Dto): CommunicationSubTab[] =>
  event.eventContext.type === "Public"
    ? ["questions", "publicQa", "information", "clarifications", "internal"]
    : ["questions", "information", "internal"];

export const parseCommunicationSubTab = (
  value: string | null,
  visible: CommunicationSubTab[],
): CommunicationSubTab => {
  const found = visible.find((subTab) => subTab === value);
  return found ?? visible[0];
};
